var $ae7c36a9a232c303$exports = {};
$ae7c36a9a232c303$exports = {
    "collapse": `\u{C811}\u{AE30}`,
    "expand": `\u{D3BC}\u{CE58}\u{AE30}`
};


export {$ae7c36a9a232c303$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
